import { tSetTableConfig, tTables } from "./types";

export const setTableConfig = (key: tTables, config: Record<string, boolean>): tSetTableConfig => {
  return {
    type: "SET_TABLE_CONFIG",
    key,
    config,
  };
};
